import React from 'react';
import { useCallback, useEffect, useRef, useState } from "react"
import { useWavesurfer } from "./useWavesurfer";
import { Duration } from "./Duration";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { IconButton } from '@mui/material';
import './waveSurferPlayer.css';

export const WaveSurferPlayer = (props: any) => {
    const containerRef = useRef<any>();
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const wavesurfer = useWavesurfer(containerRef, props);
    const [waveformWidth, setWaveformWidth] = useState(duration * 100);

    const onPlayClick = useCallback(() => {
      wavesurfer?.isPlaying() ? wavesurfer?.pause() : wavesurfer?.play()
    }, [wavesurfer])

    useEffect(() => {
      if (!wavesurfer) return

      setCurrentTime(0)
      setIsPlaying(false)

      setDuration(wavesurfer.getDuration());
      setWaveformWidth(duration * 100)
      const subscriptions = [
        wavesurfer.on('play', () => setIsPlaying(true)),
        wavesurfer.on('pause', () => setIsPlaying(false)),
        wavesurfer.on('timeupdate', (currentTime) => {
          const currentTimeCentiseconds = Math.round(currentTime * 100);
          setCurrentTime(currentTimeCentiseconds)})
      ]

      wavesurfer.on('ready', () => {
        setDuration(Math.round(wavesurfer.getDuration() * 100));
      });

      return () => {
        subscriptions.forEach((unsub) => unsub())
      }
    }, [wavesurfer])

    return (
      <>
        <div className="container-wave-surfer" style={{ backgroundColor: '#24242e' }}>
            <IconButton onClick={onPlayClick} size='small' sx={{ color: 'rgba(255,255,255,0.85)', flexShrink: 0 }}>
              {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
            </IconButton>

            <div className="container-time-progress">
                <div className="container-time-from-start">
                    <Duration centiseconds={currentTime} />
                </div>
                <div className="container-time-to-end">
                    -<Duration centiseconds={duration - currentTime} />
                </div>
            </div>

            <div className="wave-surfer" ref={containerRef} />
        </div>
      </>
    )
  }
